module.exports = {
  wrapRootElement: require("./browser/wrapRootElement"),
}
